import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { merge } from 'lodash';
import CssBaseline from '@material-ui/core/CssBaseline';
import FuseUITheme from 'fuse-ui/theme/theme-provider';
import React, { Component } from 'react';

import PropTypes from 'prop-types';

import {
    createSessionInFlightSelector,
    isInitialLoadSelector,
    isMaintenanceFlagSelector,
    isSessionValidSelector
} from './common/selectors/ui-state-selectors';
import {
    validateSession
} from './common/actions/authentication-action-creators';
import EfdRoutes from './efd-routes';
import InitNewRelicScript from './common/components/init-new-relic-script';
import themeOverrides from './common/theme/theme-provider';


const styles = theme => ( {
    root: {
        display: 'flex'
    }
} );

export class App extends Component{
    componentDidMount(){
        const { validateSession } = this.props;
        validateSession();
    }

    render(){
        const {
            classes,
            createSessionInFlight,
            isInitialLoad,
            isSessionValid,
            maintenanceFlag,
        } = this.props;

        //Allow overrides of the fuse theme for components that are not in the Fuse-Ui theme yet.
        const FuseTheme = merge( FuseUITheme, themeOverrides );
        return (
            <Router>
                <MuiThemeProvider theme={FuseTheme}>
                    <CssBaseline />
                    <div className={classes.root}>
                        <EfdRoutes
                            maintenanceFlag={maintenanceFlag}
                            isSessionValid={isSessionValid}
                            isInitialLoad={isInitialLoad}
                            createSessionInFlight={createSessionInFlight}
                        />
                    </div>
                    <InitNewRelicScript />
                </MuiThemeProvider>
            </Router>
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        createSessionInFlight: createSessionInFlightSelector( state ),
        isInitialLoad: isInitialLoadSelector( state ),
        isSessionValid: isSessionValidSelector( state ),
        maintenanceFlag: isMaintenanceFlagSelector( state ),
    };
};

const mapDispatchToProps = {
    validateSession,
};


App.propTypes = {
    classes: PropTypes.object.isRequired,
    createSessionInFlight: PropTypes.bool,
    isInitialLoad: PropTypes.bool,
    isSessionValid: PropTypes.bool,
    maintenanceFlag: PropTypes.bool,
    validateSession: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, mapDispatchToProps )( withStyles( styles )( App ) );
